import * as R from 'remeda'

import { type DiffValue } from './types'

type GetDiffTextOptions<T extends string> = {
  /**
   * 比較列値のテキストを取得する関数。
   *
   * @param item - 比較列値。
   * @returns 比較列値のテキスト。
   */
  textFn?: (item: T) => string
  /**
   * 区切り文字。省略した場合、改行文字。
   */
  separator?: string
}

/**
 * 比較列のテキストを取得します。
 *
 * @template T - 比較列値の型。
 * @param diff - 比較列。
 * @param options - オプション。
 * @returns 比較列のテキスト。
 */
export function getDiffText<T extends string>(
  diff: DiffValue<T>,
  options: GetDiffTextOptions<T> = {},
) {
  const [left, right] = diff
  const { separator = '\n', textFn = R.identity() } = options

  return [textFn(left), 'vs', textFn(right)].join(separator)
}
